<template>
  <CRow class="">
    <template v-if="!isPrint">
      <CCol v-if="activeScheduling" :class="{ isPrint: isPrint }" class="col-12">
        <CRow class="align-items-center background-indicadores" style="height: 60px">
          <CCol sm="4" class="pl-3 d-flex">
            <p class="d-flex align-self-center mb-0">
              <CIcon name="smsFull" size="custom-size" :height="25" viewBox="0 0 32 32" class="mr-3" />
              <span class="font-2xl">
                {{ activeScheduling.totalSMSCount }}
              </span>
              <span class="text-gray-800 font-1xl ml-2">{{ $t('campaign.campaignResult.dashboard.smsEngagement.text.smsSent') }}</span>
            </p>
          </CCol>
          <CCol sm="3" class="pl-3 d-flex">
            <p class="d-flex align-self-center mb-0">
              <CIcon name="userBgFull" :height="25" viewBox="0 0 32 32" class="mr-2 text-gray-400" />
              <span class="font-2xl">
                {{ activeScheduling.totalRecipientsCount }}
              </span>
              <span class="text-gray-800 font-1xl ml-2">{{ $t('campaign.campaignResult.dashboard.smsEngagement.text.recipients') }}</span>
            </p>
          </CCol>
          <CCol sm="3">
            <div class="sent-date">
              {{ $t('campaign.campaignResult.dashboard.smsEngagement.text.sentOn') }}

              {{ activeScheduling.schedulingDatetime ? formatDateTimeFull(activeScheduling.schedulingDatetime, null, null, false) : '' }}
              ({{ activeScheduling.timezone }})
            </div>
          </CCol>
          <CCol sm="2" v-if="countPages > 1">
            <CustomPagination class="align" :activePage.sync="activePage" :countPages="countPages" />
          </CCol>
        </CRow>
        <CRow class="border-line-bottom">
          <CCol sm="3" class="border-line-right pt-5">
            <div class="font-weight-semi-bold sent-date">
              {{ $t('campaign.campaignResult.dashboard.smsEngagement.text.sender') }}
            </div>
            <div class="mb-4">
              {{ activeScheduling.senderName }}
            </div>
            <div class="font-weight-semi-bold sent-date">
              {{ $t('campaign.campaignResult.dashboard.smsEngagement.text.message') }}
            </div>
            <div class="scroll-area-message mt-2">
              {{ activeScheduling.content }}
            </div>
          </CCol>
          <CCol>
            <CRow>
              <CCol sm="7" class="pt-5 pl-5 pr-2">
                <CRow>
                  <CCol>
                    <apexchart type="radialBar" :options="chartOptionsSuccess" :series="seriesDelivered" width="160" v-if="reloadShart"></apexchart>
                    <div class="pl-4">
                      <a @click="goToResume('delivered')" class="text-blue link-clickable">{{
                        $t('campaign.campaignResult.dashboard.smsEngagement.link.delivered')
                      }}</a>
                      <div class="mt-2 individual-engagement">
                        {{ activeScheduling.performance.deliveredCount }}
                      </div>
                      <div class="text-gray-600 mt-1">
                        {{ $t('campaign.campaignResult.dashboard.smsEngagement.link.sms') }}
                      </div>
                    </div>
                  </CCol>
                  <CCol>
                    <apexchart
                      type="radialBar"
                      :options="chartOptionsSuccess"
                      :series="seriesNotdelivered"
                      width="160"
                      v-if="reloadShart"
                    ></apexchart>
                    <div class="pl-4">
                      <a @click="goToResume('notdelivered')" class="text-blue link-clickable">{{
                        $t('campaign.campaignResult.dashboard.smsEngagement.link.notDelivered')
                      }}</a>
                      <div class="mt-2 individual-engagement">
                        {{ activeScheduling.performance.notDeliveredCount }}
                      </div>
                      <div class="text-gray-600 mt-1">
                        {{ $t('campaign.campaignResult.dashboard.smsEngagement.link.sms') }}
                      </div>
                    </div>
                  </CCol>
                  <CCol>
                    <apexchart type="radialBar" :options="chartOptionsWarning" :series="seriesPending" width="160" v-if="reloadShart"></apexchart>
                    <div class="pl-4">
                      <a @click="goToResume('pending')" class="text-orange link-clickable">{{
                        $t('campaign.campaignResult.dashboard.smsEngagement.link.pending')
                      }}</a>
                      <div class="mt-2 individual-engagement">
                        {{ activeScheduling.performance.pendingCount }}
                      </div>
                      <div class="text-gray-600 mt-1">
                        {{ $t('campaign.campaignResult.dashboard.smsEngagement.link.sms') }}
                      </div>
                    </div>
                  </CCol>
                </CRow>
              </CCol>
              <CCol sm="5" class="pt-5">
                <div class="font-weight-semi-bold sent-date px-2">
                  {{ $t('campaign.campaignResult.dashboard.smsEngagement.text.topLocations') }}
                </div>
                <div class="scroll-area-message mt-2 px-3">
                  <div v-for="(country, index) in activeSchedulingSortedByLocationSent" :key="index">
                    <CRow>
                      <CCol sm="2" style="padding-right: 0px" class="text-right">
                        <img :src="getFlag(country.countryId)" width="30" />
                      </CCol>
                      <CCol sm="4" class="text-gray-600">
                        {{ country.countryId }}
                      </CCol>
                      <CCol sm="3" class="text-gray-600 text-right">
                        {{ country.count }}
                      </CCol>
                      <CCol sm="3" class="text-gray-base"> {{ topLocationPercent(activeScheduling, country.count) }}% </CCol>
                    </CRow>
                    <hr class="mt-1" />
                  </div>
                </div>
              </CCol>
            </CRow>
          </CCol>
        </CRow>
      </CCol>
    </template>

    <template v-if="isPrint">
      <CRow class="sms__section">
        <CCol>
          <h3 class="font-weight-normal p-4">SMS</h3>
        </CCol>
        <CCol sm="12" class="mt-2 sms__item" v-for="(items, index) in smsSchedulingSortedByLocation" :key="index">
          <CCol class="p-0 m-0">
            <CRow class="align-items-center background-indicadores" style="height: 70px">
              <CCol sm="4" class="pl-3 d-flex">
                <p class="total-sent d-flex align-self-center mb-0">
                  <CIcon name="smsFull" size="custom-size" :height="18" viewBox="0 0 32 32" class="mr-3" />
                  {{ items.totalRecipientsCount }}
                  <span class="total-sent-msg font-sm ml-2">{{ $t('campaign.campaignResult.dashboard.smsEngagement.text.smsSent') }}</span>
                </p>
              </CCol>
              <CCol sm="3" class="pl-3 d-flex">
                <p class="total-recipients d-flex align-self-center mb-0">
                  <CIcon name="userBgFull" size="custom-size" :height="22" viewBox="0 0 32 32" class="mr-2" />
                  {{ items.totalRecipientsCount }}
                  <span class="total-sent-msg font-sm ml-2">{{ $t('campaign.campaignResult.dashboard.smsEngagement.text.recipients') }}</span>
                </p>
              </CCol>
              <CCol sm="3">
                <div class="sent-date">
                  {{ $t('campaign.campaignResult.dashboard.smsEngagement.text.sentOn') }}
                  {{ items.schedulingDatetime ? formatDateTimeFull(new Date(items.schedulingDatetime).toISOString()) : '' }}
                </div>
              </CCol>
            </CRow>

            <CRow class="border-line-bottom">
              <CCol sm="3" class="border-line-right pt-5">
                <div class="font-weight-semi-bold sent-date">
                  {{ $t('campaign.campaignResult.dashboard.smsEngagement.text.message') }}
                </div>
                <div class="scroll-area-message mt-2">
                  {{ items.content }}
                </div>
              </CCol>
              <CCol>
                <CRow>
                  <CCol sm="7" class="pt-4 pl-5 pr-2">
                    <CRow>
                      <CCol>
                        <apexchart
                          type="radialBar"
                          :options="chartOptionsSuccess"
                          :series="seriesDelivered"
                          width="160"
                          v-if="reloadShart"
                        ></apexchart>
                        <div class="pl-4">
                          <a @click="goToResume('delivered')" class="text-blue link-clickable">{{
                            $t('campaign.campaignResult.dashboard.smsEngagement.link.delivered')
                          }}</a>
                          <div class="mt-2 individual-engagement">
                            {{ items.performance.deliveredCount }}
                          </div>
                          <div class="text-gray-600 mt-1">
                            {{ $t('campaign.campaignResult.dashboard.smsEngagement.link.sms') }}
                          </div>
                        </div>
                      </CCol>
                      <CCol>
                        <apexchart
                          type="radialBar"
                          :options="chartOptionsSuccess"
                          :series="seriesNotdelivered"
                          width="160"
                          v-if="reloadShart"
                        ></apexchart>
                        <div class="pl-4">
                          <a @click="goToResume('notdelivered')" class="text-blue link-clickable">{{
                            $t('campaign.campaignResult.dashboard.smsEngagement.link.notDelivered')
                          }}</a>
                          <div class="mt-2 individual-engagement">
                            {{ items.performance.notDeliveredCount }}
                          </div>
                          <div class="text-gray-600 mt-1">
                            {{ $t('campaign.campaignResult.dashboard.smsEngagement.link.sms') }}
                          </div>
                        </div>
                      </CCol>
                      <CCol>
                        <apexchart type="radialBar" :options="chartOptionsWarning" :series="seriesPending" width="160" v-if="reloadShart"></apexchart>
                        <div class="pl-4">
                          <a @click="goToResume('pending')" class="text-orange link-clickable">{{
                            $t('campaign.campaignResult.dashboard.smsEngagement.link.pending')
                          }}</a>
                          <div class="mt-2 individual-engagement">
                            {{ items.performance.pendingCount }}
                          </div>
                          <div class="text-gray-600 mt-1">
                            {{ $t('campaign.campaignResult.dashboard.smsEngagement.link.sms') }}
                          </div>
                        </div>
                      </CCol>
                    </CRow>
                  </CCol>
                  <CCol sm="5" class="pt-5">
                    <div class="font-weight-semi-bold sent-date px-2">
                      {{ $t('campaign.campaignResult.dashboard.smsEngagement.text.topLocations') }}
                    </div>
                    <div class="scroll-area-message mt-2 px-3">
                      <div v-for="(country, index) in items.performance.topLocations.sent" :key="index">
                        <CRow>
                          <CCol sm="2" style="padding-right: 0px" class="text-right">
                            <img :src="getFlag(country.countryId)" width="30" />
                          </CCol>
                          <CCol sm="4" class="text-gray-600">
                            {{ country.countryId ? country.countryId : $t('components.toplocatinos.Unknown') }}
                          </CCol>
                          <CCol sm="3" class="text-gray-600 text-right">
                            {{ country.sentCount }}
                          </CCol>
                          <CCol sm="3" class="text-gray-base"> {{ '100' }}% </CCol>
                        </CRow>
                        <hr class="mt-1" />
                      </div>
                    </div>
                  </CCol>
                </CRow>
              </CCol>
            </CRow>
          </CCol>
        </CCol>
      </CRow>
    </template>
  </CRow>
</template>

<script>
import { dateFormatStringFull } from '@/utils/dateUtil.js'
import VueApexCharts from 'vue-apexcharts'
import countries from '../../../../../countriesList'
import CustomPagination from '@/components/CustomPagination'

export default {
  props: {
    campaignResult: Object,
    isPrint: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    apexchart: VueApexCharts,
    CustomPagination,
  },
  data() {
    return {
      activePage: 1,
      scheduling: null,
      seriesSent: [0],
      seriesDelivered: [0],
      seriesNotdelivered: [0],
      seriesPending: [0],
      reloadShart: true,
      chartOptionsSuccess: {
        chart: {
          type: 'radialBar',
          offsetY: -15,
          offsetX: -25,
          sparkline: {
            enabled: true,
          },
        },
        plotOptions: {
          radialBar: {
            track: {
              background: '#e7e7e7',
              strokeWidth: '98%',
              margin: 15,
              dropShadow: {
                enabled: false,
                top: 2,
                left: 0,
                color: '#999',
                opacity: 1,
                blur: 2,
              },
            },
            dataLabels: {
              name: {
                show: false,
              },
              value: {
                offsetY: 6,
                fontSize: '20px',
              },
            },
          },
        },
        grid: {
          padding: {
            top: -10,
          },
        },
        fill: {
          type: 'solid',
        },
        labels: [''],
        colors: ['#6ebff3'],
      },
      chartOptionsWarning: {
        chart: {
          type: 'radialBar',
          offsetY: -15,
          offsetX: -25,
          sparkline: {
            enabled: true,
          },
        },
        plotOptions: {
          radialBar: {
            track: {
              background: '#e7e7e7',
              strokeWidth: '98%',
              margin: 15,
              dropShadow: {
                enabled: false,
                top: 2,
                left: 0,
                color: '#999',
                opacity: 1,
                blur: 2,
              },
            },
            dataLabels: {
              name: {
                show: false,
              },
              value: {
                offsetY: 6,
                fontSize: '20px',
              },
            },
          },
        },
        grid: {
          padding: {
            top: -10,
          },
        },
        fill: {
          type: 'solid',
        },
        labels: [''],
        colors: ['#ee9200'],
      },
    }
  },
  computed: {
    countPages: function () {
      if (this.campaignResult.channels) {
        return this.campaignResult.channels.sms.schedulings.length
      }
      return 0
    },
    activeScheduling: function () {
      if (this.campaignResult.channels) {
        return this.campaignResult.channels.sms.schedulings[this.activePage - 1]
      }
      return null
    },
    activeSchedulingSortedByLocationSent() {
      return this.activeScheduling.performance.topLocations.sent.sort((a, b) => b.count - a.count)
    },
    smsSchedulingSortedByLocation() {
      return this.campaignResult.channels.sms.schedulings.map((items) => {
        return {
          ...items,
          performance: {
            topLocations: {
              sent: items.performance.topLocations.sent.sort((a, b) => b.count - a.count),
            },
          },
        }
      })
    },
  },
  watch: {
    activeScheduling: function (newSchedule) {
      if (newSchedule) {
        this.calculatingPercent()
      }
    },
  },
  methods: {
    formatDateTimeFull(date, timezone, format, changeZone = true) {
      return dateFormatStringFull(date, timezone, format, changeZone)
    },

    getFlag(key) {
      return countries.find((elm) => elm.code?.toUpperCase() === key?.toUpperCase())?.flag
    },

    goToResume(type) {
      this.$router.push({
        name: 'campaignResume',
        params: {
          campaignId: this.$route.params.campaignId,
          scheduleType: 'sms',
          scheduleId: this.activeScheduling.schedulingId,
          type: type,
        },
      })
    },

    calculatingPercent() {
      if (this.activeScheduling && this.activeScheduling.performance && this.activeScheduling.totalRecipientsCount > 0) {
        let totalRecipientsCount = isNaN(this.activeScheduling.totalRecipientsCount) ? 0 : this.activeScheduling.totalRecipientsCount
        let deliveredCount = isNaN(this.activeScheduling.performance.deliveredCount) ? 0 : this.activeScheduling.performance.deliveredCount
        let notDeliveredCount = isNaN(this.activeScheduling.performance.notDeliveredCount) ? 0 : this.activeScheduling.performance.notDeliveredCount
        let pendingCount = isNaN(this.activeScheduling.performance.pendingCount) ? 0 : this.activeScheduling.performance.pendingCount

        this.seriesDelivered = [totalRecipientsCount > 0 ? Math.round((deliveredCount * 100) / totalRecipientsCount) : 0]
        this.seriesNotdelivered = [totalRecipientsCount > 0 ? Math.round((notDeliveredCount * 100) / totalRecipientsCount) : 0]
        this.seriesPending = [totalRecipientsCount > 0 ? Math.round((pendingCount * 100) / totalRecipientsCount) : 0]

        this.reloadShart = false
        this.$nextTick(() => {
          this.reloadShart = true
        })
      }
    },

    seriesDeliveredItem(item) {
      if (item && item.performance && item.totalRecipientsCount > 0) {
        this.seriesDelivered = [Math.round((item.performance.deliveredCount * 100) / item.totalRecipientsCount)]

        this.reloadShart = false
        this.$nextTick(() => {
          this.reloadShart = true
        })
      }
    },

    seriesNotdeliveredItem(item) {
      if (item && item.performance && item.totalRecipientsCount > 0) {
        this.seriesNotdelivered = [Math.round((item.performance.notDeliveredCount * 100) / item.totalRecipientsCount)]
        this.reloadShart = false
        this.$nextTick(() => {
          this.reloadShart = true
        })
      }
    },

    seriesPendingItem(item) {
      if (item && item.performance && item.totalRecipientsCount > 0) {
        this.seriesNotdelivered = [Math.round((item.performance.notDeliveredCount * 100) / item.totalRecipientsCount)]
        this.reloadShart = false
        this.$nextTick(() => {
          this.reloadShart = true
        })
      }
    },

    topLocationPercent(item, value) {
      let result = 0
      if (item && item.performance && item.performance.deliveredCount > 0) {
        result = Math.round((value * 100) / item.performance.deliveredCount)
      }
      // if (item && item.performance && item.totalRecipientsCount > 0) {
      //   result = Math.round((value * 100) / item.totalRecipientsCount)
      // }
      return result > 100 ? 100 : result
    },
  },
  mounted() {
    this.calculatingPercent()
  },
}
</script>

<style lang="scss" scope>
.border-line-bottom {
  border-bottom: 1px solid $gray-500;
}

.border-line-right {
  border-right: 1px solid $gray-500;
}

.text-blue {
  color: #6ebff3 !important;
}

.link-clickable {
  text-decoration: underline !important;
  font-size: $font-size-xs1;
  cursor: pointer;
}

.total-sent {
  font-size: $font-size-xl;
  color: $gray-base;
  font-weight: 200;
}

.total-sent-msg {
  font-size: $font-size-base;
  color: $gray-600;
  font-weight: 500;
}

.total-recipients {
  font-size: $font-size-md2;
  color: $gray-600;
}

.total-recipients-msg {
  font-size: $font-size-base;
  color: $gray-600;
  font-weight: 500;
}

.sent-date {
  font-size: $font-size-base;
  color: $gray-600;
  font-weight: 500;
}

.page-active {
  color: $gray-700;
  font-weight: 600;
}

.scroll-area-message {
  overflow-y: auto;
  height: 250px;
}

.individual-engagement {
  font-size: $font-size-md;
  color: $gray-700;
}

.pagination-margin ul {
  margin: 0px !important;
  align-self: center;
}

.background-indicadores {
  background-color: $gray-200;

  icon {
    fill: $gray-300 !important;
  }
}
</style>
